import React from 'react';
import { FormLabel, FormHelperText, FormErrorMessage, FormControl, Box } from '@chakra-ui/react';
import { DatePicker } from 'antd5';
import { DownChevron } from '../../Icons/DownChevron';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { WarningTwoIcon } from '@chakra-ui/icons';
import './singleDateField.css';

dayjs.extend(weekday);
dayjs.extend(localeData);

export interface SingleDateFieldProps {
  id: string;
  value: any | dayjs.Dayjs;
  initialDate?: any | dayjs.Dayjs;
  isInvalid?: boolean;
  label?: string;
  helperText?: string;
  errorText?: string;
  minDate?: dayjs.Dayjs;
  maxDate?: dayjs.Dayjs;
  isEditable?: boolean;
  onChange: (date: dayjs.Dayjs | null) => void;
}

export const SingleDateField = ({
  id,
  initialDate,
  value,
  isInvalid,
  helperText,
  errorText,
  label,
  onChange,
  minDate,
  maxDate,
  isEditable,
}: SingleDateFieldProps) => {
  return (
    <FormControl id={id} isInvalid={isInvalid}>
      {label && (
        <FormLabel fontFamily="Poppins" color="text.base" mb={1}>
          {label}
        </FormLabel>
      )}
      <Box role="group">
        <DatePicker
          id={id}
          format="DD/MM/YYYY"
          value={value}
          //this is already extended with weekday and localeData
          //@ts-ignore
          onChange={(date) => onChange(date)}
          suffixIcon={
            <Box position={'relative'}>
              {isInvalid && (
                <Box position={'absolute'} right={10} pointerEvents={'none'}>
                  <WarningTwoIcon color={'error'} />
                </Box>
              )}
              <DownChevron color={isEditable ? 'primary.base' : '#8C8C8C'} _groupHover={{ color: 'primary.light' }} />
            </Box>
          }
          placeholder="DD/MM/YYYY"
          showToday={false}
          style={{ height: '48px', width: '100%' }}
          disabledDate={(day) => (minDate && day < minDate) || (maxDate && day > maxDate) || false}
          defaultPickerValue={initialDate}
        />
      </Box>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <FormErrorMessage>{errorText}</FormErrorMessage>
    </FormControl>
  );
};
